<!-- ─── Header bar ─────────────────────────────────────────────── -->
<header
  class="navbar"
  [class.navbar--scrolled]="isScrolled()"
  role="banner">

  <div class="navbar__inner">
    <!-- Mobile hamburger (left edge) -->
    <button
      type="button"
      class="navbar__hamburger"
      aria-label="Toggle navigation menu"
      [attr.aria-expanded]="mobileMenuOpen()"
      (click)="toggleMobileMenu()">
      <span class="navbar__hamburger-line" [class.navbar__hamburger-line--open]="mobileMenuOpen()"></span>
      <span class="navbar__hamburger-line" [class.navbar__hamburger-line--open]="mobileMenuOpen()"></span>
      <span class="navbar__hamburger-line" [class.navbar__hamburger-line--open]="mobileMenuOpen()"></span>
    </button>

    <!-- ─── Desktop capsule ─────────────────────────────────────── -->
    <nav
      class="navbar__capsule"
      role="navigation"
      aria-label="Main navigation">

      <div class="navbar__capsule-nav" role="tablist">
        <!-- Sliding pill -->
        <div
          class="navbar__pill"
          aria-hidden="true"
          [class.navbar__pill--hidden]="!activeTabId()"
          [style.left]="pillLeftPx()"
          [style.width]="pillWidthPx()">
        </div>

        @for (item of navItems(); track item.id) {
          <sh-nav-item
            [item]="item"
            [isActive]="isTabActive(item)"
            (tabActivated)="onTabActivated(item)"
            role="tab"
            [attr.aria-selected]="isTabActive(item)">
          </sh-nav-item>
        }
      </div>
    </nav>

    <!-- ─── Right controls ──────────────────────────────────────── -->
    <div class="navbar__controls">
      <!-- Mode toggle (desktop only — mobile has its own in the drawer) -->
      <div class="navbar__desktop-only">
        <sh-mode-toggle
          [isSettingsMode]="isSettingsMode()"
          (modeChanged)="onModeChanged($event)" />
      </div>

      <!-- Notifications (hidden at 1024–1087px, shown in dropdown instead) -->
      <button
        type="button"
        class="navbar__icon-btn navbar__desktop-only navbar__wide-desktop-only"
        title="Notifications"
        aria-label="Notifications">
        <lucide-angular [img]="bellIcon" [size]="18"></lucide-angular>
      </button>

      <!-- Theme toggle (hidden at 1024–1087px, shown in dropdown instead) -->
      <button
        type="button"
        class="navbar__icon-btn navbar__desktop-only navbar__wide-desktop-only"
        title="Toggle theme"
        aria-label="Toggle theme"
        (click)="toggleTheme()">
        🌓
      </button>

      <!-- User avatar -->
      <div class="navbar__user-menu relative">
        <button
          type="button"
          class="navbar__avatar"
          aria-label="User menu"
          [attr.aria-expanded]="userMenuOpen()"
          (click)="toggleUserMenu()">
          <span>{{ avatarInitials() }}</span>
        </button>

        @if (userMenuOpen()) {
          <div class="navbar__user-dropdown" role="menu">
            <!-- Shown only at 1024–1087px -->
            <button
              type="button"
              class="navbar__user-dropdown-item navbar__narrow-desktop-only"
              role="menuitem"
              aria-label="Notifications">
              Notifications
            </button>
            <button
              type="button"
              class="navbar__user-dropdown-item navbar__narrow-desktop-only"
              role="menuitem"
              (click)="toggleTheme()">
              Toggle Theme
            </button>
            <hr class="navbar__user-dropdown-divider navbar__narrow-desktop-only" />

            <a class="navbar__user-dropdown-item" role="menuitem" routerLink="/settings/me">
              Profile
            </a>
            <button
              type="button"
              class="navbar__user-dropdown-item"
              role="menuitem"
              (click)="goToSettingsFromMenu()">
              Settings
            </button>
            <button
              type="button"
              class="navbar__user-dropdown-item"
              role="menuitem"
              [attr.aria-pressed]="fullscreen.isFullscreen()"
              (click)="toggleFullscreen()">
              {{ fullscreen.isFullscreen() ? 'Exit fullscreen' : 'Fullscreen' }}
            </button>
            <hr class="navbar__user-dropdown-divider" />
            <button
              type="button"
              class="navbar__user-dropdown-item navbar__user-dropdown-item--danger"
              role="menuitem"
              (click)="signOut()">
              Sign out
            </button>
          </div>
        }
      </div>

    </div>
  </div>
</header>

<!-- ─── Mobile overlay ────────────────────────────────────────── -->
@if (mobileMenuOpen()) {
  <div class="mobile-overlay" (click)="closeMobileMenu()"></div>

  <nav
    class="mobile-menu"
    role="navigation"
    aria-label="Mobile navigation">
    <!-- Mobile mode toggle -->
    <div class="mobile-menu__mode">
      <sh-mode-toggle
        [isSettingsMode]="isSettingsMode()"
        (modeChanged)="onModeChanged($event)" />
      <span class="mobile-menu__mode-label">
        {{ isSettingsMode() ? 'Settings' : 'Operations' }}
      </span>
    </div>

    <div class="mobile-menu__list">
      @for (item of navItems(); track item.id) {
        <div class="mobile-menu__section">
          <div class="mobile-menu__item-row">
            <button
              type="button"
              class="mobile-menu__item"
              [class.mobile-menu__item--active]="isTabActive(item)"
              (click)="onMobileItemClick(item)">
              {{ item.label }}
            </button>

            @if (item.children && item.children.length > 0) {
              <button
                type="button"
                class="mobile-menu__expand"
                [attr.aria-expanded]="isMobileExpanded(item.id)"
                (click)="toggleMobileSection(item.id)">
                <lucide-angular
                  [img]="chevronDownIcon"
                  [size]="16"
                  [class.mobile-menu__expand-icon--open]="isMobileExpanded(item.id)">
                </lucide-angular>
              </button>
            }
          </div>

          @if (item.children && isMobileExpanded(item.id)) {
            <div class="mobile-menu__children">
              @for (child of item.children; track child.id) {
                <button
                  type="button"
                  class="mobile-menu__child"
                  (click)="onMobileChildClick(child.route)">
                  {{ child.label }}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  </nav>
}
